import { render } from "./AppSettings.vue?vue&type=template&id=5262d564&scoped=true&ts=true"
import script from "./AppSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSettings.vue?vue&type=script&setup=true&lang=ts"

import "./AppSettings.vue?vue&type=style&index=0&id=5262d564&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5262d564"],['__file',"src/components/AppSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5262d564"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5262d564', __exports__)) {
    api.reload('5262d564', __exports__)
  }
  
  module.hot.accept("./AppSettings.vue?vue&type=template&id=5262d564&scoped=true&ts=true", () => {
    api.rerender('5262d564', render)
  })

}


export default __exports__